import * as React from 'react'
import { ClientDetails } from '@models/clients'
import { Card, CardBody, Row } from 'reactstrap'
import { ColAuto } from '@hyper/col-auto'
import { IconWithText } from '@components/icon-with-text'
import { ClientDetailsModalClientProfilePersonalDataTable } from './client-profile-personal-data-table'
import { ClientDetailsModalClientProfilePersonalDataForm } from '@modules/crm/clients/details-modal/client-profile/client-profile-personal-data-form'

interface Props {
  client: ClientDetails
}

export const ClientDetailsModalClientProfilePersonalData: React.FC<Props> = ({ client }) => {
  const [isEditMode, setIsEditMode] = React.useState(false)

  const toggleEditMode = () => setIsEditMode(state => !state)

  return (
    <Card className="card-grey">
      <CardBody className="card-body-grey">
        <Row>
          <ColAuto>
            <h5 className="mt-0">Dane osobowe</h5>
          </ColAuto>
          {!isEditMode && (
            <ColAuto className="col-auto ml-auto">
              <IconWithText
                icon="uil-edit-alt font-16"
                text="zmień"
                wrapperClassNames="cursor-pointer text-secondary"
                textClass="font-10 text-semi-strong"
                onClick={toggleEditMode}
              />
            </ColAuto>
          )}
        </Row>
        {isEditMode ? (
          <ClientDetailsModalClientProfilePersonalDataForm client={client} toggleEditMode={toggleEditMode} />
        ) : (
          <ClientDetailsModalClientProfilePersonalDataTable client={client} />
        )}
      </CardBody>
    </Card>
  )
}
